import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';

import React, { useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import ButtonML from '@/components/button_ml/ButtonML';
import { Form, message } from 'antd';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import { hasUndefInObj } from '../../../../../../utils/breUtils';

const HandleTabel = (props) => {
  const { name, id, handleClick } = props;
  const dispatch = useDispatch();
  const unitInput = useRef(null);
  const [form] = Form.useForm();

  const fetchData = useCallback(() => {
    dispatch({
      type: 'UnitTest/getUnitTest',
      payload: {
        values: {
          id: id,
          // brandId: brandId,
        },
      },
    });
  }, [dispatch, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const inputList = useSelector((state) => state.UnitTest.getUnitTest);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['UnitTest/getUnitTest'];
  const columns = [
    {
      title: '输入字段',
      dataIndex: 'desc',
      key: 'desc',
      render: (text) => <span>{text}</span>,
    },
    {
      title: '输入值',
      dataIndex: 'operator',
      key: 'operator',
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            placeVal="请输入值"
            className="no_label"
            name={record.name}
            refs={unitInput}
          />
        );
      },
    },
  ];
  const hanleClick = () => {
    const formVal = form.getFieldsValue();
    if (hasUndefInObj(formVal, undefined) || hasUndefInObj(formVal, '')) {
      return message.warning('请填写完整');
    }
    //查询exp
    dispatch({
      type: 'UnitTest/getTest',
      payload: {
        values: {
          id: id,
          ...formVal,
        },
      },
      callback: (d) => {
        if (d.code && d.code !== 0) {
          message.warning(d.message);
        } else {
          if (JSON.stringify(d?.valueMap) === '{}') {
            message.warning('测试完成, 未命中规则');
          } else {
            message.success('测试完成');
          }
          handleClick(d);
        }
      },
    });
  };
  const hanleReset = () => {
    form.resetFields();
  };
  return (
    <Form form={form} name="unit">
      <DataTable
        border={true}
        className="demo-test"
        style={{
          minWidth: '1547px',
          minHeight: '400px',
          border: '1px solid #edf0f0',
          marginTop: '1rem',
        }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(100vh - 160px - 3rem)' }}
        dataSource={inputList}
        loading={loading}
        title={() => (
          <div className="rule_name">
            <span>规则名称</span>
            {name}
          </div>
        )}
        footer={() => (
          <>
            <ButtonML
              size="large"
              value="执行"
              htmlType="submit"
              fontsize="16px"
              onClick={() => hanleClick()}
            />
            <ButtonML
              size="large"
              value="重置"
              fontsize="16px"
              onClick={() => hanleReset()}
            />
          </>
        )}
      />
    </Form>
  );
};
export default HandleTabel;
